// extracted by mini-css-extract-plugin
export var option = "_96-0";
export var optionCard = "_96-f";
export var optionContent = "_96-g";
export var optionIcon = "_96-i";
export var optionIconBox = "_96-h";
export var optionLabel = "_96-j";
export var optionPill = "_96-m";
export var optionPillBadge = "_96-p";
export var optionPillIcon = "_96-n";
export var optionPillLabel = "_96-o";
export var optionRadio = "_96-k";
export var optionRadioInner = "_96-l";
export var optionReveal = "_96-2";
export var optionRevealDelay0 = "_96-3";
export var optionRevealDelay1 = "_96-4";
export var optionRevealDelay10 = "_96-d";
export var optionRevealDelay11 = "_96-e";
export var optionRevealDelay2 = "_96-5";
export var optionRevealDelay3 = "_96-6";
export var optionRevealDelay4 = "_96-7";
export var optionRevealDelay5 = "_96-8";
export var optionRevealDelay6 = "_96-9";
export var optionRevealDelay7 = "_96-a";
export var optionRevealDelay8 = "_96-b";
export var optionRevealDelay9 = "_96-c";
export var optionSelected = "_96-1";